export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.5de8ce54.worker.js");
}
